module.exports = __webpack_public_path__ + "img/shoukuanbeijingtu.d1f668f5.png";